import apiClient from '../../../Services/ApiClient';

export const printInvoice = async ({ url }: { url: string }) => {
	const response = await apiClient.get(url);

	if (response.status === 200 && response.data) {
		const iframe = document.createElement('iframe');
		iframe.style.display = 'none';
		iframe.srcdoc = response.data;

		iframe.onload = () => {
			const printWindow = iframe.contentWindow;
			if (!printWindow) {
				iframe.remove();
				return;
			}

			printWindow.onafterprint = () => {
				iframe.remove();
			};

			printWindow.focus();
			printWindow.print();
		};

		document.body.appendChild(iframe);
	}
};
